<div class="confirm-container">
    <div class="confirmation-content">
        <div class="title">
            <span>{{title}}</span>
        </div>
        <div class="description">
            <span>{{message}}</span>
        </div>
    </div>
    <div class="action-block">
        <button *ngIf="!hideClose" class="cancel-button" mat-button (click)="cancel()">{{'cancel' | translate}}</button>
        <button class="confirm-button" mat-button (click)="confirm()">Ok</button>
    </div>
</div>